import { defineElement, defineElementNoInputs, } from '..';
export function wrapDefineElement(options) {
    var _a, _b;
    const { assertInputs, transformInputs } = {
        assertInputs: (_a = options === null || options === void 0 ? void 0 : options.assertInputs) !== null && _a !== void 0 ? _a : (() => { }),
        transformInputs: (_b = options === null || options === void 0 ? void 0 : options.transformInputs) !== null && _b !== void 0 ? _b : ((inputs) => inputs),
    };
    return {
        defineElement: () => {
            return (inputs) => {
                assertInputs(inputs);
                return defineElement()(transformInputs(inputs));
            };
        },
        defineElementNoInputs: (inputs) => {
            assertInputs(inputs);
            return defineElementNoInputs(transformInputs(inputs));
        },
    };
}
